module.exports = __webpack_public_path__ + "static/img/listJD.bdd8af3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/listJD.jpg
// module id = MIMl
// module chunks = 6